export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:image","content":"https://www.rwa-estate.com/hero.png"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"RWA Estate"},{"name":"twitter:description","content":"Explore Tokenized Real Estate"},{"name":"twitter:image","content":"https://www.rwa-estate.com/hero.png"},{"name":"keywords","content":"Tokenized Real Estate, Property Investment, Trending Properties, Real Estate Aggregator, Real Estate Tokenization, Investment Opportunities, New Property Offers, Real Estate Blockchain, Property Growth Rates"},{"property":"og:type","content":"website"}],"style":[],"script":[],"noscript":[],"title":"RWA Estate | Explore Tokenized Real Estate","htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"